// extracted by mini-css-extract-plugin
export default {"container":"component_form_uuid_container__tIBPz","description":"component_form_uuid_description__cwVg-"};